import { useCallback, useState } from 'react'

export function useToggle(defaultValue?: boolean) {
  const [isShown, setIsShown] = useState(defaultValue || false)

  const toggle = useCallback(() => {
    setIsShown((s) => !s)
  }, [])

  return {
    isShown,
    toggle,
  }
}
